import React from 'react';
import {
  IcoClockWithShield,
  IcoClockWithSquare,
  IdleMachineStateIcons
} from 'icons/indexed-icons/IcoClock';
import { IcoWrench } from 'icons/indexed-icons/IcoWrench';
import { IcoCleaning } from 'icons/indexed-icons/IcoCleaning';
import CheckCircle2 from 'icons/indexed-icons/CheckCircle2';
import { colors } from '../protein';

//machine status
import { default as DisconnectedIcon } from '../../../../../components/MachineStatus/icons/status_disconnected.svg';
import { default as ConnectedIcon } from '../../../../../components/MachineStatus/icons/status_connected.svg';
import TriangleWarning from 'icons/indexed-icons/TriangleWarning';
import AlarmMachineStatus from 'icons/indexed-icons/AlarmMachineStatus';
import NotRunningStatus from 'icons/indexed-icons/NotRunningStatus';
import PausedMachineStatus from 'icons/indexed-icons/PausedMachineStatus';

export const Icons: Record<string, JSX.Element> = {
  idle: <IdleMachineStateIcons />,
  maintenance: <IcoWrench />,
  cleaning: <IcoCleaning />,
  sterilzation: <IcoClockWithShield />,
  'wait time': <IcoClockWithSquare />,
  online: <CheckCircle2 color={colors?.['online']} />,
  connected: <img className="machine_status" src={ConnectedIcon} />,
  disconnected: <img className="machine_status" src={DisconnectedIcon} />,
  'unknown': <TriangleWarning color={colors?.['unknown']}/>,
  running: <CheckCircle2 color={colors?.['running']} />,
  'alarm': <AlarmMachineStatus />,
  'not running': <NotRunningStatus />,
  'stop by alarm': <AlarmMachineStatus />,
  'paused': <PausedMachineStatus />,
  'stop_alarm': <AlarmMachineStatus />,
  'stop': <PausedMachineStatus />,
};
